import React from 'react';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import './upper-controls.scss';
import { useSelector } from 'react-redux';
interface UpperControlsProps {
    search: string;
    setSearch: (value: string) => void;
    showFilters: boolean;
    setShowFilters: (value: boolean) => void;
    selectedFilters: string[];
    setSelectedFilters: (value: string[]) => void;
    handleFilterToggle: (name: string) => void;
    handleSelectAllFilters: (checked: boolean) => void;
    uniqueProductNames: string[];
    onShowModifications: () => void;
    hasModifications: () => boolean;
}

const UpperControls = ({ 
    search, 
    setSearch, 
    showFilters, 
    setShowFilters, 
    selectedFilters, 
    setSelectedFilters, 
    handleFilterToggle, 
    handleSelectAllFilters, 
    uniqueProductNames,
    onShowModifications,
    hasModifications
}: UpperControlsProps) => {
    const bulkLoading = useSelector((state: any) => state.product.bulk_loading);
    return (
        <div className="stock-table__upper">
            <div className="stock-table__upper__controls">
                <span className="p-inputgroup">
                    <span className="p-inputgroup-addon">
                        <i className="pi pi-search"></i>
                    </span>
                    <InputText 
                        placeholder="Search..." 
                        className="stock-table__upper__controls__filter-button" 
                        onChange={(e) => setSearch(e.target.value)} 
                        value={search}
                    />
                </span>
                <div className="stock-table__filter-container">
                    <Button 
                        onClick={() => setShowFilters(!showFilters)} 
                        icon="pi pi-filter" 
                        label={''} 
                        className={`stock-table__upper__controls__filter-button ${showFilters ? 'p-button-highlighted' : ''} ${selectedFilters.length > 0 ? 'filters-active' : ''}`} 
                    />
                </div>
                <div className="stock-table__filter-container">
                    <Button onClick={onShowModifications} icon={bulkLoading ? "pi pi-spinner pi-spin" : "pi pi-save"} 
                        iconPos='left' disabled={!hasModifications() || bulkLoading} label={''} className="stock-table__upper__controls__save-button" />
                </div>
            </div>
        </div>
    );
};

export default UpperControls; 